<template>
  <div class="popup" v-if="loading">
    <head-title class="head-title">Confirmation...</head-title>
    <div class="popup__body">
      <spinner-el class="spinner"/>
      <div class="popup__notice">Confirming</div>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    loading: true,
  }),
  mounted() {
    const token = this.$route.query.token;
    if (!token) {
      this.$router.replace('/email-confirm/token-invalid');
      return;
    }
    this.$apiService.confirmEmail(token).then(() => {
      this.$router.replace('/email-confirm/success');
    }).catch(() => {
      this.$router.replace('/email-confirm/token-invalid');
    });
  },
};
</script>

<style lang="scss" scoped>
  .popup {
    max-width: 420px;
    background: $white-color2;
    border-radius: 5px;
    margin: auto;
    &__body {
      padding: 24px 30px 57px;
    }
    &__notice {
      text-align: center;
      @include font(13px, $grey-color9, 500);
      line-height: 21px;
    }
    .head-title {
      @include font(24px, $black-color1, medium);
      border-bottom: 1px solid $white-color5;
      padding: 32px 28px;
    }
    .spinner {
      margin: 36px auto 26px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/pages/EmailConfirm.vue